import React from "react";

export default function BracketLines({ lines, svgSize, colorScheme }) {
 return (
  <svg
   style={{
    position: "absolute",
    top: 0,
    left: 0,
    pointerEvents: "none",
    zIndex: 0,
   }}
   width={svgSize.width}
   height={svgSize.height}
  >
   {lines.map((line, idx) => (
    <line
     key={idx}
     x1={line.x1}
     y1={line.y1}
     x2={line.x2}
     y2={line.y2}
     stroke={colorScheme === "yellow-black" ? "#fff" : "black"}
     strokeWidth={2}
    />
   ))}
  </svg>
 );
}
